export default "__VITE_ASSET__DSAzH7g6__"